const ReleaseType = [
	'Original',
	'Broadcast',
	'DVD',
	'Blu-ray',
	'PayTV',
	'InternetBuy',
	'InternetRent',
	'Theatrical',
	'SVOD'
]

const package_types = [
	'tv',
	'movie'
]

const WorkType = [
	'movie',
	'episode',
	'promotion',
	'season',
	'series',
	'promotion',
	'supplemental'
]

// const WorkTypeLabels = {
// 	movie: 'Movie',
// 	episode: 'Episode',
// 	promotion: 'Promotion',
// 	supplemental: 'Supplemental',
// 	season: 'Saison',
// 	series: 'Série'
// }

const relationshipType = [
	'isepisodeof',
	'isseasonof',
	'ispromotionfor',
	'issupplementto'
]

const countries = [
	{ text: 'Afghanistan', code: 'AF' },
	{ text: 'Afrique du Sud', code: 'ZA' },
	{ text: 'Îles Åland', code: 'AX' },
	{ text: 'Albanie', code: 'AL' },
	{ text: 'Algérie', code: 'DZ' },
	{ text: 'Allemagne', code: 'DE' },
	{ text: 'Andorre', code: 'AD' },
	{ text: 'Angola', code: 'AO' },
	{ text: 'Anguilla', code: 'AI' },
	{ text: 'Antarctique', code: 'AQ' },
	{ text: 'Antigua-et-Barbuda', code: 'AG' },
	{ text: 'Arabie saoudite', code: 'SA' },
	{ text: 'Argentine', code: 'AR' },
	{ text: 'Arménie', code: 'AM' },
	{ text: 'Aruba', code: 'AW' },
	{ text: 'Australie', code: 'AU' },
	{ text: 'Autriche', code: 'AT' },
	{ text: 'Azerbaïdjan', code: 'AZ' },
	{ text: 'Bahamas', code: 'BS' },
	{ text: 'Bahreïn', code: 'BH' },
	{ text: 'Bangladesh', code: 'BD' },
	{ text: 'Barbade', code: 'BB' },
	{ text: 'Biélorussie', code: 'BY' },
	{ text: 'Belgique', code: 'BE' },
	{ text: 'Belize', code: 'BZ' },
	{ text: 'Bénin', code: 'BJ' },
	{ text: 'Bermudes', code: 'BM' },
	{ text: 'Bhoutan', code: 'BT' },
	{ text: 'Bolivie', code: 'BO' },
	{ text: 'Pays-Bas caribéens', code: 'BQ' },
	{ text: 'Bosnie-Herzégovine', code: 'BA' },
	{ text: 'Botswana', code: 'BW' },
	{ text: 'Île Bouvet', code: 'BV' },
	{ text: 'Brésil', code: 'BR' },
	{ text: 'Brunei', code: 'BN' },
	{ text: 'Bulgarie', code: 'BG' },
	{ text: 'Burkina Faso', code: 'BF' },
	{ text: 'Burundi', code: 'BI' },
	{ text: 'Îles Caïmans', code: 'KY' },
	{ text: 'Cambodge', code: 'KH' },
	{ text: 'Cameroun', code: 'CM' },
	{ text: 'Canada', code: 'CA' },
	{ text: 'Cap-Vert', code: 'CV' },
	{ text: 'République centrafricaine', code: 'CF' },
	{ text: 'Chili', code: 'CL' },
	{ text: 'Chine', code: 'CN' },
	{ text: 'Île Christmas', code: 'CX' },
	{ text: 'Chypre (pays)', code: 'CY' },
	{ text: 'Îles Cocos', code: 'CC' },
	{ text: 'Colombie', code: 'CO' },
	{ text: 'Comores (pays)', code: 'KM' },
	{ text: 'République du Congo', code: 'CG' },
	{ text: 'République démocratique du Congo', code: 'CD' },
	{ text: 'Îles Cook', code: 'CK' },
	{ text: 'Corée du Sud', code: 'KR' },
	{ text: 'Corée du Nord', code: 'KP' },
	{ text: 'Costa Rica', code: 'CR' },
	{ text: 'Côte d\'Ivoire', code: 'CI' },
	{ text: 'Croatie', code: 'HR' },
	{ text: 'Cuba', code: 'CU' },
	{ text: 'Curaçao', code: 'CW' },
	{ text: 'Danemark', code: 'DK' },
	{ text: 'Djibouti', code: 'DJ' },
	{ text: 'République dominicaine', code: 'DO' },
	{ text: 'Dominique', code: 'DM' },
	{ text: 'Égypte', code: 'EG' },
	{ text: 'Salvador', code: 'SV' },
	{ text: 'Émirats arabes unis', code: 'AE' },
	{ text: 'Équateur (pays)', code: 'EC' },
	{ text: 'Érythrée', code: 'ER' },
	{ text: 'Espagne', code: 'ES' },
	{ text: 'Estonie', code: 'EE' },
	{ text: 'États-Unis', code: 'US' },
	{ text: 'Éthiopie', code: 'ET' },
	{ text: 'Malouines', code: 'FK' },
	{ text: 'Îles Féroé', code: 'FO' },
	{ text: 'Fidji', code: 'FJ' },
	{ text: 'Finlande', code: 'FI' },
	{ text: 'France', code: 'FR' },
	{ text: 'Gabon', code: 'GA' },
	{ text: 'Gambie', code: 'GM' },
	{ text: 'Géorgie (pays)', code: 'GE' },
	{ text: 'Géorgie du Sud-et-les îles Sandwich du Sud', code: 'GS' },
	{ text: 'Ghana', code: 'GH' },
	{ text: 'Gibraltar', code: 'GI' },
	{ text: 'Grèce', code: 'GR' },
	{ text: 'Grenade (pays)', code: 'GD' },
	{ text: 'Groenland', code: 'GL' },
	{ text: 'Guadeloupe', code: 'GP' },
	{ text: 'Guam', code: 'GU' },
	{ text: 'Guatemala', code: 'GT' },
	{ text: 'Guernesey', code: 'GG' },
	{ text: 'Guinée', code: 'GN' },
	{ text: 'Guinée-Bissau', code: 'GW' },
	{ text: 'Guinée équatoriale', code: 'GQ' },
	{ text: 'Guyana', code: 'GY' },
	{ text: 'Guyane', code: 'GF' },
	{ text: 'Haïti', code: 'HT' },
	{ text: 'Îles Heard-et-MacDonald', code: 'HM' },
	{ text: 'Honduras', code: 'HN' },
	{ text: 'Hong Kong', code: 'HK' },
	{ text: 'Hongrie', code: 'HU' },
	{ text: 'Île de Man', code: 'IM' },
	{ text: 'Îles mineures éloignées des États-Unis', code: 'UM' },
	{ text: 'Îles Vierges britanniques', code: 'VG' },
	{ text: 'Îles Vierges des États-Unis', code: 'VI' },
	{ text: 'Inde', code: 'IN' },
	{ text: 'Indonésie', code: 'ID' },
	{ text: 'Iran', code: 'IR' },
	{ text: 'Irak', code: 'IQ' },
	{ text: 'Irlande (pays)', code: 'IE' },
	{ text: 'Islande', code: 'IS' },
	{ text: 'Israël', code: 'IL' },
	{ text: 'Italie', code: 'IT' },
	{ text: 'Jamaïque', code: 'JM' },
	{ text: 'Japon', code: 'JP' },
	{ text: 'Jersey', code: 'JE' },
	{ text: 'Jordanie', code: 'JO' },
	{ text: 'Kazakhstan', code: 'KZ' },
	{ text: 'Kenya', code: 'KE' },
	{ text: 'Kirghizistan', code: 'KG' },
	{ text: 'Kiribati', code: 'KI' },
	{ text: 'Koweït', code: 'KW' },
	{ text: 'Laos', code: 'LA' },
	{ text: 'Lesotho', code: 'LS' },
	{ text: 'Lettonie', code: 'LV' },
	{ text: 'Liban', code: 'LB' },
	{ text: 'Liberia', code: 'LR' },
	{ text: 'Libye', code: 'LY' },
	{ text: 'Liechtenstein', code: 'LI' },
	{ text: 'Lituanie', code: 'LT' },
	{ text: 'Luxembourg (pays)', code: 'LU' },
	{ text: 'Macao', code: 'MO' },
	{ text: 'Macédoine du Nord', code: 'MK' },
	{ text: 'Madagascar', code: 'MG' },
	{ text: 'Malaisie', code: 'MY' },
	{ text: 'Malawi', code: 'MW' },
	{ text: 'Maldives', code: 'MV' },
	{ text: 'Mali', code: 'ML' },
	{ text: 'Malte', code: 'MT' },
	{ text: 'Îles Mariannes du Nord', code: 'MP' },
	{ text: 'Maroc', code: 'MA' },
	{ text: 'Îles Marshall (pays)', code: 'MH' },
	{ text: 'Martinique', code: 'MQ' },
	{ text: 'Maurice (pays)', code: 'MU' },
	{ text: 'Mauritanie', code: 'MR' },
	{ text: 'Mayotte', code: 'YT' },
	{ text: 'Mexique', code: 'MX' },
	{ text: 'États fédérés de Micronésie (pays)', code: 'FM' },
	{ text: 'Moldavie', code: 'MD' },
	{ text: 'Monaco', code: 'MC' },
	{ text: 'Mongolie', code: 'MN' },
	{ text: 'Monténégro', code: 'ME' },
	{ text: 'Montserrat', code: 'MS' },
	{ text: 'Mozambique', code: 'MZ' },
	{ text: 'Birmanie', code: 'MM' },
	{ text: 'Namibie', code: 'NA' },
	{ text: 'Nauru', code: 'NR' },
	{ text: 'Népal', code: 'NP' },
	{ text: 'Nicaragua', code: 'NI' },
	{ text: 'Niger', code: 'NE' },
	{ text: 'Nigeria', code: 'NG' },
	{ text: 'Niue', code: 'NU' },
	{ text: 'Île Norfolk', code: 'NF' },
	{ text: 'Norvège', code: 'NO' },
	{ text: 'Nouvelle-Calédonie', code: 'NC' },
	{ text: 'Nouvelle-Zélande', code: 'NZ' },
	{ text: 'Territoire britannique de l\'océan Indien', code: 'IO' },
	{ text: 'Oman', code: 'OM' },
	{ text: 'Ouganda', code: 'UG' },
	{ text: 'Ouzbékistan', code: 'UZ' },
	{ text: 'Pakistan', code: 'PK' },
	{ text: 'Palaos', code: 'PW' },
	{ text: 'Palestine', code: 'PS' },
	{ text: 'Panama', code: 'PA' },
	{ text: 'Papouasie-Nouvelle-Guinée', code: 'PG' },
	{ text: 'Paraguay', code: 'PY' },
	{ text: 'Pays-Bas', code: 'NL' },
	{ text: 'Pérou', code: 'PE' },
	{ text: 'Philippines', code: 'PH' },
	{ text: 'Îles Pitcairn', code: 'PN' },
	{ text: 'Pologne', code: 'PL' },
	{ text: 'Polynésie française', code: 'PF' },
	{ text: 'Porto Rico', code: 'PR' },
	{ text: 'Portugal', code: 'PT' },
	{ text: 'Qatar', code: 'QA' },
	{ text: 'La Réunion', code: 'RE' },
	{ text: 'Roumanie', code: 'RO' },
	{ text: 'Royaume-Uni', code: 'GB' },
	{ text: 'Russie', code: 'RU' },
	{ text: 'Rwanda', code: 'RW' },
	{ text: 'République arabe sahraouie démocratique', code: 'EH' },
	{ text: 'Saint-Barthélemy', code: 'BL' },
	{ text: 'Saint-Christophe-et-Niévès', code: 'KN' },
	{ text: 'Saint-Marin', code: 'SM' },
	{ text: 'Saint-Martin', code: 'MF' },
	{ text: 'Saint-Martin', code: 'SX' },
	{ text: 'Saint-Pierre-et-Miquelon', code: 'PM' },
	{ text: 'Saint-Siège (État de la Cité du Vatican)', code: 'VA' },
	{ text: 'Saint-Vincent-et-les-Grenadines', code: 'VC' },
	{ text: 'Sainte-Hélène, Ascension et Tristan da Cunha', code: 'SH' },
	{ text: 'Sainte-Lucie', code: 'LC' },
	{ text: 'Salomon', code: 'SB' },
	{ text: 'Samoa', code: 'WS' },
	{ text: 'Samoa américaines', code: 'AS' },
	{ text: 'Sao Tomé-et-Principe', code: 'ST' },
	{ text: 'Sénégal', code: 'SN' },
	{ text: 'Serbie', code: 'RS' },
	{ text: 'Seychelles', code: 'SC' },
	{ text: 'Sierra Leone', code: 'SL' },
	{ text: 'Singapour', code: 'SG' },
	{ text: 'Slovaquie', code: 'SK' },
	{ text: 'Slovénie', code: 'SI' },
	{ text: 'Somalie', code: 'SO' },
	{ text: 'Soudan', code: 'SD' },
	{ text: 'Soudan du Sud', code: 'SS' },
	{ text: 'Sri Lanka', code: 'LK' },
	{ text: 'Suède', code: 'SE' },
	{ text: 'Suisse', code: 'CH' },
	{ text: 'Suriname', code: 'SR' },
	{ text: 'Svalbard et ile Jan Mayen', code: 'SJ' },
	{ text: 'Eswatini', code: 'SZ' },
	{ text: 'Syrie', code: 'SY' },
	{ text: 'Tadjikistan', code: 'TJ' },
	{ text: 'Taïwan / (République de Chine (Taïwan))', code: 'TW' },
	{ text: 'Tanzanie', code: 'TZ' },
	{ text: 'Tchad', code: 'TD' },
	{ text: 'Tchéquie', code: 'CZ' },
	{ text: 'Terres australes et antarctiques françaises', code: 'TF' },
	{ text: 'Thaïlande', code: 'TH' },
	{ text: 'Timor oriental', code: 'TL' },
	{ text: 'Togo', code: 'TG' },
	{ text: 'Tokelau', code: 'TK' },
	{ text: 'Tonga', code: 'TO' },
	{ text: 'Trinité-et-Tobago', code: 'TT' },
	{ text: 'Tunisie', code: 'TN' },
	{ text: 'Turkménistan', code: 'TM' },
	{ text: 'Îles Turques-et-Caïques', code: 'TC' },
	{ text: 'Turquie', code: 'TR' },
	{ text: 'Tuvalu', code: 'TV' },
	{ text: 'Ukraine', code: 'UA' },
	{ text: 'Uruguay', code: 'UY' },
	{ text: 'Vanuatu', code: 'VU' },
	{ text: 'Venezuela', code: 'VE' },
	{ text: 'Viêt Nam', code: 'VN' },
	{ text: 'Wallis-et-Futuna', code: 'WF' },
	{ text: 'Yémen', code: 'YE' },
	{ text: 'Zambie', code: 'ZM' },
	{ text: 'Zimbabwe', code: 'ZW' }
]

const genres = [
	{ text: 'Action', code: 'av_genre_action' },
	{ text: 'Action - Comedy', code: 'av_subgenre_action_comedy' },
	{ text: 'Action - Crime', code: 'av_subgenre_action_crime' },
	{ text: 'Action - Disaster', code: 'av_subgenre_action_disaster' },
	{ text: 'Action - Epic', code: 'av_subgenre_action_epic' },
	{ text: 'Action - Espionage and Spies', code: 'av_subgenre_action_espionage_and_spies' },
	{ text: 'Action - Fantasy', code: 'av_subgenre_action_fantasy' },
	{ text: 'Action - Historical', code: 'av_subgenre_action_historical' },
	{ text: 'Action - Martial Arts', code: 'av_subgenre_action_martial_arts' },
	{ text: 'Action - Military and War', code: 'av_subgenre_action_military_and_war' },
	{ text: 'Action - Peplum (Sword and Sandal)', code: 'av_subgenre_action_peplum_sword_and_sandal' },
	{ text: 'Action - Romance', code: 'av_subgenre_action_romance' },
	{ text: 'Action - Science Fiction', code: 'av_subgenre_action_science_fiction' },
	{ text: 'Action - Superheroes', code: 'av_subgenre_action_superheroes' },
	{ text: 'Action - Suspense', code: 'av_subgenre_action_suspense' },
	{ text: 'Action - Tokusatsu', code: 'av_subgenre_action_tokusatsu' },
	{ text: 'Action - Western', code: 'av_subgenre_action_western' },
	{ text: 'Adventure', code: 'av_genre_adventure' },
	{ text: 'Adventure - Comedy', code: 'av_subgenre_adventure_comedy' },
	{ text: 'Adventure - Eastern', code: 'av_subgenre_adventure_eastern' },
	{ text: 'Adventure - Epic', code: 'av_subgenre_adventure_epic' },
	{ text: 'Adventure - Fantasy', code: 'av_subgenre_adventure_fantasy' },
	{ text: 'Adventure - Historical', code: 'av_subgenre_adventure_historical' },
	{ text: 'Adventure - Peplum (Sword and Sandal)', code: 'av_subgenre_adventure_peplum_sword_and_sandal' },
	{ text: 'Adventure - Romance', code: 'av_subgenre_adventure_romance' },
	{ text: 'Animation, Adult Interest', code: 'av_genre_animation_adult_interest' },
	{ text: 'Animation - Action', code: 'av_subgenre_animation_action' },
	{ text: 'Animation - Adventure', code: 'av_subgenre_animation_adventure' },
	{ text: 'Animation - Comedy', code: 'av_subgenre_animation_comedy' },
	{ text: 'Animation - Drama', code: 'av_subgenre_animation_drama' },
	{ text: 'Animation - Fantasy', code: 'av_subgenre_animation_fantasy' },
	{ text: 'Animation - Horror', code: 'av_subgenre_animation_horror' },
	{ text: 'Animation - Romance', code: 'av_subgenre_animation_romance' },
	{ text: 'Animation - Science Fiction', code: 'av_subgenre_animation_science_fiction' },
	{ text: 'Animation - Surreal', code: 'av_subgenre_animation_surreal' },
	{ text: 'Anime', code: 'av_genre_anime' },
	{ text: 'Anime - Action', code: 'av_subgenre_anime_action' },
	{ text: 'Anime - Adventure', code: 'av_subgenre_anime_adventure' },
	{ text: 'Anime - Comedy', code: 'av_subgenre_anime_comedy' },
	{ text: 'Anime - Drama', code: 'av_subgenre_anime_drama' },
	{ text: 'Anime - Ecchi (Erotic)', code: 'av_subgenre_anime_ecchi_erotic' },
	{ text: 'Anime - Fantasy', code: 'av_subgenre_anime_fantasy' },
	{ text: 'Anime - Harem', code: 'av_subgenre_anime_harem' },
	{ text: 'Anime - Historical', code: 'av_subgenre_anime_historical' },
	{ text: 'Anime - Horror', code: 'av_subgenre_anime_horror' },
	{ text: 'Anime - Kids', code: 'av_subgenre_anime_kids' },
	{ text: 'Anime - Mecha', code: 'av_subgenre_anime_mecha' },
	{ text: 'Anime - Music', code: 'av_subgenre_anime_music' },
	{ text: 'Anime - Mystery', code: 'av_subgenre_anime_mystery' },
	{ text: 'Anime - Romance', code: 'av_subgenre_anime_romance' },
	{ text: 'Anime - School', code: 'av_subgenre_anime_school' },
	{ text: 'Anime - Science Fiction', code: 'av_subgenre_anime_science_fiction' },
	{ text: 'Anime - Shoujo', code: 'av_subgenre_anime_shoujo' },
	{ text: 'Anime - Shounen', code: 'av_subgenre_anime_shounen' },
	{ text: 'Anime - Slice of Life', code: 'av_subgenre_anime_slice_of_life' },
	{ text: 'Anime - Sports', code: 'av_subgenre_anime_sports' },
	{ text: 'Anime - Supernatural', code: 'av_subgenre_anime_supernatural' },
	{ text: 'Anime - War', code: 'av_subgenre_anime_war' },
	{ text: 'Anime - Yaoi', code: 'av_subgenre_anime_yaoi' },
	{ text: 'Anime - Yuri', code: 'av_subgenre_anime_yuri' },
	{ text: 'Arthouse', code: 'av_genre_arthouse' },
	{ text: 'Arthouse - Avant-Garde', code: 'av_subgenre_arthouse_avant_garde' },
	{ text: 'Arthouse - Experimental', code: 'av_subgenre_arthouse_experimental' },
	{ text: 'Arthouse - Surrealist', code: 'av_subgenre_arthouse_surrealist' },
	{ text: 'Arthouse - Erotic', code: 'av_subgenre_arthouse_erotic' },
	{ text: 'Arthouse - Non-narrative and Ambient', code: 'av_subgenre_arthouse_non_narrative_ambient' },
	{ text: 'Arts, Entertainment, and Culture', code: 'av_genre_arts_entertainment_and_culture' },
	{ text: 'Arts, Entertainment and Culture - Dance', code: 'av_subgenre_arts_entertainment_and_culture_dance' },
	{ text: 'Arts, Entertainment and Culture - Musical', code: 'av_subgenre_arts_entertainment_and_culture_musical' },
	{ text: 'Arts, Entertainment and Culture - Opera', code: 'av_subgenre_arts_entertainment_and_culture_opera' },
	{ text: 'Arts, Entertainment and Culture - Standup Comedy', code: 'av_subgenre_arts_entertainment_and_culture_standup_comedy' },
	{ text: 'Arts, Entertainment and Culture - Theater', code: 'av_subgenre_arts_entertainment_and_culture_theater' },
	{ text: 'Comedy', code: 'av_genre_comedy' },
	{ text: 'Comedy - Action', code: 'av_subgenre_comedy_action' },
	{ text: 'Comedy - Adventure', code: 'av_subgenre_comedy_adventure' },
	{ text: 'Comedy - Crime', code: 'av_subgenre_comedy_crime' },
	{ text: 'Comedy - Dark', code: 'av_subgenre_comedy_dark' },
	{ text: 'Comedy - Drama', code: 'av_subgenre_comedy_drama' },
	{ text: 'Comedy - Fantasy', code: 'av_subgenre_comedy_fantasy' },
	{ text: 'Comedy - Heimatfilm', code: 'av_subgenre_comedy_heimatfilm' },
	{ text: 'Comedy - High School', code: 'av_subgenre_comedy_high_school' },
	{ text: 'Comedy - Horror', code: 'av_subgenre_comedy_horror' },
	{ text: 'Comedy - Romance', code: 'av_subgenre_comedy_romance' },
	{ text: 'Comedy - Political', code: 'av_subgenre_comedy_political' },
	{ text: 'Comedy - Satire', code: 'av_subgenre_comedy_satire' },
	{ text: 'Comedy - Science Fiction', code: 'av_subgenre_comedy_science_fiction' },
	{ text: 'Comedy - Sitcom', code: 'av_subgenre_comedy_sitcom' },
	{ text: 'Documentary', code: 'av_genre_documentary' },
	{ text: 'Documentary - Art, Entertainment, and Culture', code: 'av_subgenre_documentary_art_entertainment_and_culture' },
	{ text: 'Documentary - Biography', code: 'av_subgenre_documentary_biography' },
	{ text: 'Documentary - Crime', code: 'av_subgenre_documentary_crime' },
	{ text: 'Documentary - Food and Drinks', code: 'av_subgenre_documentary_food_drinks' },
	{ text: 'Documentary - History', code: 'av_subgenre_documentary_history' },
	{ text: 'Documentary - Hobby', code: 'av_subgenre_documentary_hobby' },
	{ text: 'Documentary - Military and War', code: 'av_subgenre_documentary_military_and_war' },
	{ text: 'Documentary - Music', code: 'av_subgenre_documentary_music' },
	{ text: 'Documentary - Nature and Wildlife', code: 'av_subgenre_documentary_nature_wildlife' },
	{ text: 'Documentary - Politics', code: 'av_subgenre_documentary_politics' },
	{ text: 'Documentary - Religion', code: 'av_subgenre_documentary_religion' },
	{ text: 'Documentary - Science and Technology', code: 'av_subgenre_documentary_science_technology' },
	{ text: 'Documentary - Sports', code: 'av_subgenre_documentary_sports' },
	{ text: 'Documentary - Transportation', code: 'av_subgenre_documentary_transportation' },
	{ text: 'Documentary - Travel', code: 'av_subgenre_documentary_travel' },
	{ text: 'Drama', code: 'av_genre_drama' },
	{ text: 'Drama - Biopic', code: 'av_subgenre_drama_biopic' },
	{ text: 'Drama - Comedy', code: 'av_subgenre_drama_comedy' },
	{ text: 'Drama - Costume Drama', code: 'av_subgenre_drama_costume_drama' },
	{ text: 'Drama - Crime', code: 'av_subgenre_drama_crime' },
	{ text: 'Drama - Family Drama', code: 'av_subgenre_drama_family_drama' },
	{ text: 'Drama - Heimatfilm', code: 'av_subgenre_drama_heimatfilm' },
	{ text: 'Drama - High School', code: 'av_subgenre_drama_high_school' },
	{ text: 'Drama - Historical', code: 'av_subgenre_drama_historical' },
	{ text: 'Drama - Korean', code: 'av_subgenre_drama_korean_drama' },
	{ text: 'Drama - Medical', code: 'av_subgenre_drama_medical' },
	{ text: 'Drama - Melodrama', code: 'av_subgenre_drama_melodrama' },
	{ text: 'Drama - Military and War', code: 'av_subgenre_drama_military_and_war' },
	{ text: 'Drama - Political', code: 'av_subgenre_drama_political' },
	{ text: 'Drama - Psychological', code: 'av_subgenre_drama_psychological' },
	{ text: 'Drama - Romance', code: 'av_subgenre_drama_romance' },
	{ text: 'Drama - Soap Opera', code: 'av_subgenre_drama_soap_opera' },
	{ text: 'Drama - Suspense', code: 'av_subgenre_drama_suspense' },
	{ text: 'Drama - Tear Jerker', code: 'av_subgenre_drama_tear_jerker' },
	{ text: 'EPG', code: 'av_genre_epg' },
	{ text: 'Erotic', code: 'av_genre_erotic' },
	{ text: 'Erotic - Anime', code: 'av_subgenre_erotic_anime' },
	{ text: 'Erotic - Comedy', code: 'av_subgenre_erotic_comedy' },
	{ text: 'Erotic - Documentary', code: 'av_subgenre_erotic_documentary' },
	{ text: 'Erotic - Drama', code: 'av_subgenre_erotic_drama' },
	{ text: 'Erotic - Fantasy', code: 'av_subgenre_erotic_fantasy' },
	{ text: 'Erotic - Horror', code: 'av_subgenre_erotic_horror' },
	{ text: 'Erotic - LGBTQ', code: 'av_subgenre_erotic_lgbtq' },
	{ text: 'Erotic - Romance', code: 'av_subgenre_erotic_romance' },
	{ text: 'Erotic - Thriller', code: 'av_subgenre_erotic_thriller' },
	{ text: 'Faith and Spirituality', code: 'av_genre_faith_and_spirituality' },
	{ text: 'Faith and Spirituality – Buddhism', code: 'av_subgenre_faith_spirituality_buddhism' },
	{ text: 'Faith and Spirituality – Christianity', code: 'av_subgenre_faith_spirituality_christianity' },
	{ text: 'Faith and Spirituality – Hinduism', code: 'av_subgenre_faith_spirituality_hinduism' },
	{ text: 'Faith and Spirituality – Islam', code: 'av_subgenre_faith_spirituality_islam' },
	{ text: 'Faith and Spirituality – Judaism', code: 'av_subgenre_faith_spirituality_judaism' },
	{ text: 'Faith and Spirituality – New Age', code: 'av_subgenre_faith_spirituality_new_age' },
	{ text: 'Faith and Spirituality - Other', code: 'av_subgenre_faith_spirituality_other' },
	{ text: 'Faith and Spirituality - Sikhism', code: 'av_subgenre_faith_spirituality_sikhism' },
	{ text: 'Fantasy', code: 'av_genre_fantasy' },
	{ text: 'Fantasy - Action', code: 'av_subgenre_fantasy_action' },
	{ text: 'Fantasy - Adventure', code: 'av_subgenre_fantasy_adventure' },
	{ text: 'Fantasy - Comedy', code: 'av_subgenre_fantasy_comedy' },
	{ text: 'Fantasy - Dark', code: 'av_subgenre_fantasy_dark' },
	{ text: 'Fantasy - Drama', code: 'av_subgenre_fantasy_drama' },
	{ text: 'Fantasy - Epic', code: 'av_subgenre_fantasy_epic' },
	{ text: 'Fantasy - Horror', code: 'av_subgenre_fantasy_horror' },
	{ text: 'Fantasy - Mythology', code: 'av_subgenre_fantasy_mythology' },
	{ text: 'Fantasy - Romance', code: 'av_subgenre_fantasy_romance' },
	{ text: 'Fantasy - Science Fantasy', code: 'av_subgenre_fantasy_science_fantasy' },
	{ text: 'Fantasy - Sword and Sorcery', code: 'av_subgenre_fantasy_sword_sorcery' },
	{ text: 'Fitness', code: 'av_genre_fitness' },
	{ text: 'Fitness - Barre', code: 'av_subgenre_fitness_barre' },
	{ text: 'Fitness - Dance', code: 'av_subgenre_fitness_dance' },
	{ text: 'Fitness - Interval Training', code: 'av_subgenre_fitness_interval_training' },
	{ text: 'Fitness - Martial Arts and Boxing', code: 'av_subgenre_fitness_martial_arts_boxing' },
	{ text: 'Fitness - Pilates', code: 'av_subgenre_fitness_pilates' },
	{ text: 'Fitness - Spin', code: 'av_subgenre_fitness_spin' },
	{ text: 'Fitness - Strength Training', code: 'av_subgenre_fitness_strength_training' },
	{ text: 'Fitness - Yoga', code: 'av_subgenre_fitness_yoga' },
	{ text: 'Historical', code: 'av_genre_historical' },
	{ text: 'Historical - Action', code: 'av_subgenre_historical_action' },
	{ text: 'Historical - Adventure', code: 'av_subgenre_historical_adventure' },
	{ text: 'Historical - Comedy', code: 'av_subgenre_historical_comedy' },
	{ text: 'Historical - Drama', code: 'av_subgenre_historical_drama' },
	{ text: 'Historical - Epic', code: 'av_subgenre_historical_epic' },
	{ text: 'Historical - Fantasy', code: 'av_subgenre_historical_fantasy' },
	{ text: 'Historical - Peplum (Sword and Sandal)', code: 'av_subgenre_historical_peplum_sword_and_sandal' },
	{ text: 'Historical - Romance', code: 'av_subgenre_historical_romance' },
	{ text: 'Historical - Swashbuckler', code: 'av_subgenre_historical_swashbuckler' },
	{ text: 'Horror', code: 'av_genre_horror' },
	{ text: 'Horror - Action', code: 'av_subgenre_horror_action' },
	{ text: 'Horror - Adventure', code: 'av_subgenre_horror_adventure' },
	{ text: 'Horror - Comedy', code: 'av_subgenre_horror_comedy' },
	{ text: 'Horror - Demons and Exorcisms', code: 'av_subgenre_horror_demons_exorcisms' },
	{ text: 'Horror - Fantasy', code: 'av_subgenre_horror_fantasy' },
	{ text: 'Horror - Monsters', code: 'av_subgenre_horror_monsters' },
	{ text: 'Horror - Mystery', code: 'av_subgenre_horror_mystery' },
	{ text: 'Horror - Psychological', code: 'av_subgenre_horror_psychological' },
	{ text: 'Horror - Science Fiction', code: 'av_subgenre_horror_science_fiction' },
	{ text: 'Horror - Slasher', code: 'av_subgenre_horror_slasher' },
	{ text: 'Horror - Supernatural and Ghosts', code: 'av_subgenre_horror_supernatural_ghosts' },
	{ text: 'Horror - Suspense', code: 'av_subgenre_horror_suspense' },
	{ text: 'Idols', code: 'av_genre_idols' },
	{ text: 'Idol - Male Idol', code: 'av_subgenre_idol_male_idol' },
	{ text: 'Idol - Female Idol', code: 'av_subgenre_idol_female_idol' },
	{ text: 'International', code: 'av_genre_international' },
	{ text: 'International - Australia and New Zealand', code: 'av_subgenre_international_australia_and_new_zealand' },
	{ text: 'International - Canada', code: 'av_subgenre_international_canada' },
	{ text: 'International - Caribbean', code: 'av_subgenre_international_caribbean' },
	{ text: 'International - Central Africa', code: 'av_subgenre_international_central_africa' },
	{ text: 'International - Central America', code: 'av_subgenre_international_central_america' },
	{ text: 'International - Central Asia', code: 'av_subgenre_international_central_asia' },
	{ text: 'International - China', code: 'av_subgenre_international_china' },
	{ text: 'International - East Africa', code: 'av_subgenre_international_east_africa' },
	{ text: 'International - East and Southeast Asia', code: 'av_subgenre_international_east_southeast_asia' },
	{ text: 'International - Eastern Europe', code: 'av_subgenre_international_eastern_europe' },
	{ text: 'International - France', code: 'av_subgenre_international_france' },
	{ text: 'International - Germany', code: 'av_subgenre_international_germany' },
	{ text: 'International - India', code: 'av_subgenre_international_india' },
	{ text: 'International - Israel', code: 'av_subgenre_international_israel' },
	{ text: 'International - Japan', code: 'av_subgenre_international_japan' },
	{ text: 'International - Korea', code: 'av_subgenre_international_korea' },
	{ text: 'International - Mexico', code: 'av_subgenre_international_mexico' },
	{ text: 'International - Middle East', code: 'av_subgenre_international_middle_east' },
	{ text: 'International - North Africa', code: 'av_subgenre_international_north_africa' },
	{ text: 'International - Russia', code: 'av_subgenre_international_russia' },
	{ text: 'International - Scandinavia', code: 'av_subgenre_international_scandinavia' },
	{ text: 'International - South America', code: 'av_subgenre_international_south_america' },
	{ text: 'International - Southern Africa', code: 'av_subgenre_international_southern_africa' },
	{ text: 'International - Southern Europe', code: 'av_subgenre_international_southern_europe' },
	{ text: 'International - Turkey', code: 'av_subgenre_international_turkey' },
	{ text: 'International - UK', code: 'av_subgenre_international_uk' },
	{ text: 'International - West Africa', code: 'av_subgenre_international_west_africa' },
	{ text: 'International - Western Europe', code: 'av_subgenre_international_western_europe' },
	{ text: 'Kids', code: 'av_genre_kids' },
	{ text: 'Kids - Action', code: 'av_subgenre_kids_action' },
	{ text: 'Kids - Adventure', code: 'av_subgenre_kids_adventure' },
	{ text: 'Kids - Animation', code: 'av_subgenre_kids_animation' },
	{ text: 'Kids - Anime', code: 'av_subgenre_kids_anime' },
	{ text: 'Kids - Comedy', code: 'av_subgenre_kids_comedy' },
	{ text: 'Kids - Competition (Game Shows)', code: 'av_subgenre_kids_competition_game_shows' },
	{ text: 'Kids - Documentary', code: 'av_subgenre_kids_documentary' },
	{ text: 'Kids - EDUtainment', code: 'av_subgenre_kids_edutainment' },
	{ text: 'Kids  - Family', code: 'av_subgenre_kids_family' },
	{ text: 'Kids - Fantasy', code: 'av_subgenre_kids_fantasy' },
	{ text: 'Kids - How-To', code: 'av_subgenre_kids_how_to' },
	{ text: 'Kids - Let\'s Play', code: 'av_subgenre_kids_lets_play' },
	{ text: 'Kids - Musical', code: 'av_subgenre_kids_musical' },
	{ text: 'Kids - Mystery', code: 'av_subgenre_kids_mystery' },
	{ text: 'Kids - Performance (Music/Play)', code: 'av_subgenre_kids_performance' },
	{ text: 'Kids - Romance', code: 'av_subgenre_kids_romance' },
	{ text: 'Kids - Science Fiction', code: 'av_subgenre_kids_science_fiction' },
	{ text: 'Kids - Spooky', code: 'av_subgenre_kids_spooky' },
	{ text: 'Kids - Unscripted (Reality TV)', code: 'av_subgenre_kids_unscripted_reality_tv' },
	{ text: 'Kids - Variety Shows', code: 'av_subgenre_kids_variety' },
	{ text: 'LGBTQ', code: 'av_genre_lgbtq' },
	{ text: 'LGBTQ - Asexual', code: 'av_subgenre_lgbtq_asexual' },
	{ text: 'LGBTQ - Bisexual', code: 'av_subgenre_lgbtq_bisexual' },
	{ text: 'LGBTQ - Erotic', code: 'av_subgenre_lgbtq_erotic' },
	{ text: 'LGBTQ - Gay', code: 'av_subgenre_lgbtq_gay' },
	{ text: 'LGBTQ - Gender Queer/Nonbinary', code: 'av_subgenre_lgbtq_gender_queer_and_nonbinary' },
	{ text: 'LGBTQ - Lesbian', code: 'av_subgenre_lgbtq_lesbian' },
	{ text: 'LGBTQ - Trans', code: 'av_subgenre_lgbtq_trans' },
	{ text: 'Military and War', code: 'av_genre_military_and_war' },
	{ text: 'Military and War - Action', code: 'av_subgenre_military_and_war_action' },
	{ text: 'Military and War - Adventure', code: 'av_subgenre_military_and_war_adventure' },
	{ text: 'Military and War - Biopic', code: 'av_subgenre_military_and_war_biopic' },
	{ text: 'Military and War - Comedy', code: 'av_subgenre_military_and_war_comedy' },
	{ text: 'Military and War - Drama', code: 'av_subgenre_military_and_war_drama' },
	{ text: 'Military and War - Epic', code: 'av_subgenre_military_and_war_epic' },
	{ text: 'Military and War - Pre 1800', code: 'av_subgenre_military_and_war_pre_1800' },
	{ text: 'Military and War - 1800 to 1850', code: 'av_subgenre_military_and_war_1800_to_1850' },
	{ text: 'Military and War - 1850 to 1900', code: 'av_subgenre_military_and_war_1850_to_1900' },
	{ text: 'Military and War - 1900 to 1939', code: 'av_subgenre_military_and_war_1900_to_1939' },
	{ text: 'Military and War - 1939 to 1955', code: 'av_subgenre_military_and_war_1939_to_1955' },
	{ text: 'Military and War - 1955 to 1975', code: 'av_subgenre_military_and_war_1955_to_1975' },
	{ text: 'Military and War - 1975 to 1992', code: 'av_subgenre_military_and_war_1975_to_1992' },
	{ text: 'Military and War - 1992 to 2001', code: 'av_subgenre_military_and_war_1992_to_2001' },
	{ text: 'Military and War - 2001 to Present', code: 'av_subgenre_military_and_war_2001_to_present' },
	{ text: 'Military and War - Romance', code: 'av_subgenre_military_and_war_romance' },
	{ text: 'Military and War - Science Fiction', code: 'av_subgenre_military_and_war_science_fiction' },
	{ text: 'Music Videos and Concerts', code: 'av_genre_music_videos_and_concerts' },
	{ text: 'Music Videos and Concerts - African', code: 'av_subgenre_music_videos_and_concerts_african' },
	{ text: 'Music Videos and Concerts - Afro-Pop', code: 'av_subgenre_music_videos_and_concerts_afro_pop' },
	{ text: 'Music Videos and Concerts - Blues', code: 'av_subgenre_music_videos_and_concerts_blues' },
	{ text: 'Music Videos and Concerts - Caribbean', code: 'av_subgenre_music_videos_and_concerts_caribbean' },
	{ text: 'Music Videos and Concerts - Country', code: 'av_subgenre_music_videos_and_concerts_country' },
	{ text: 'Music Videos and Concerts - East Asian', code: 'av_subgenre_music_videos_and_concerts_east_asian' },
	{ text: 'Music Videos and Concerts - East Asian Jpop', code: 'av_subgenre_music_videos_and_concerts_east_asian_jpop' },
	{ text: 'Music Videos and Concerts - East Asian Kpop', code: 'av_subgenre_music_videos_and_concerts_east_asian_kpop' },
	{ text: 'Music Videos and Concerts - Easy Listening', code: 'av_subgenre_music_videos_and_concerts_easy_listening' },
	{ text: 'Music Videos and Concerts - Electronica', code: 'av_subgenre_music_videos_and_concerts_electronica' },
	{ text: 'Music Videos and Concerts - Folk', code: 'av_subgenre_music_videos_and_concerts_folk' },
	{ text: 'Music Videos and Concerts - Funk', code: 'av_subgenre_music_videos_and_concerts_funk' },
	{ text: 'Music Videos and Concerts - Gospel', code: 'av_subgenre_music_videos_and_concerts_gospel' },
	{ text: 'Music Videos and Concerts - Hip Hop', code: 'av_subgenre_music_videos_and_concerts_hip_hop' },
	{ text: 'Music Videos and Concerts - Indian', code: 'av_subgenre_music_videos_and_concerts_indian' },
	{ text: 'Music Videos and Concerts - Indian Classical', code: 'av_subgenre_music_videos_and_concerts_indian_classical' },
	{ text: 'Music Videos and Concerts - Indian Filmi', code: 'av_subgenre_music_videos_and_concerts_indian_filmi' },
	{ text: 'Music Videos and Concerts - Jazz', code: 'av_subgenre_music_videos_and_concerts_jazz' },
	{ text: 'Music Videos and Concerts - Klezmer', code: 'av_subgenre_music_videos_and_concerts_klezmer' },
	{ text: 'Music Videos and Concerts - Latin', code: 'av_subgenre_music_videos_and_concerts_latin' },
	{ text: 'Music Videos and Concerts - Latin - Banda', code: 'av_subgenre_music_videos_and_concerts_latin__banda' },
	{ text: 'Music Videos and Concerts - Latin - Merengue', code: 'av_subgenre_music_videos_and_concerts_latin__merengue' },
	{ text: 'Music Videos and Concerts - Latin Salsa', code: 'av_subgenre_music_videos_and_concerts_latin_salsa' },
	{ text: 'Music Videos and Concerts - Latin Sertanejo', code: 'av_subgenre_music_videos_and_concerts_latin_sertanejo' },
	{ text: 'Music Videos and Concerts - Middle Eastern', code: 'av_subgenre_music_videos_and_concerts_middle_eastern' },
	{ text: 'Music Videos and Concerts - New Age', code: 'av_subgenre_music_videos_and_concerts_new_age' },
	{ text: 'Music Videos and Concerts - Opera and Operette', code: 'av_subgenre_music_videos_and_concerts_opera_operette' },
	{ text: 'Music Videos and Concerts - Pop', code: 'av_subgenre_music_videos_and_concerts_pop' },
	{ text: 'Music Videos and Concerts - Pop Folk', code: 'av_subgenre_music_videos_and_concerts_pop_folk' },
	{ text: 'Music Videos and Concerts - R&B and Soul', code: 'av_subgenre_music_videos_and_concerts_rb_and_soul' },
	{ text: 'Music Videos and Concerts - Rap', code: 'av_subgenre_music_videos_and_concerts_rap' },
	{ text: 'Music Videos and Concerts - Religious', code: 'av_subgenre_music_videos_and_concerts_religious' },
	{ text: 'Music Videos and Concerts - Rock', code: 'av_subgenre_music_videos_and_concerts_rock' },
	{ text: 'Music Videos and Concerts - Western Classical', code: 'av_subgenre_music_videos_and_concerts_western_classical' },
	{ text: 'Romance', code: 'av_genre_romance' },
	{ text: 'Romance - Action', code: 'av_subgenre_romance_action' },
	{ text: 'Romance - Comedy', code: 'av_subgenre_romance_comedy' },
	{ text: 'Romance - Drama and Melodrama', code: 'av_subgenre_romance_drama_and_melodrama' },
	{ text: 'Romance - Fantasy', code: 'av_subgenre_romance_fantasy' },
	{ text: 'Romance - Historical', code: 'av_subgenre_romance_historical' },
	{ text: 'Romance - Suspense', code: 'av_subgenre_romance_suspense' },
	{ text: 'Romance - Tragedy', code: 'av_subgenre_romance_tragedy' },
	{ text: 'Science Fiction', code: 'av_genre_science_fiction' },
	{ text: 'Science Fiction - Action', code: 'av_subgenre_science_fiction_action' },
	{ text: 'Science Fiction - Adventure', code: 'av_subgenre_science_fiction_adventure' },
	{ text: 'Science Fiction - Aliens', code: 'av_subgenre_science_fiction_aliens' },
	{ text: 'Science Fiction - Apocalyptic and Post-Apocalyptic', code: 'av_subgenre_science_fiction_apocalyptic_postapocalyptic' },
	{ text: 'Science Fiction - Cyberpunk', code: 'av_subgenre_science_fiction_cyberpunk' },
	{ text: 'Science Fiction - Comedy', code: 'av_subgenre_science_fiction_comedy' },
	{ text: 'Science Fiction - Drama', code: 'av_subgenre_science_fiction_drama' },
	{ text: 'Science Fiction - Dystopian', code: 'av_subgenre_science_fiction_dystopian' },
	{ text: 'Science Fiction - Horror', code: 'av_subgenre_science_fiction_horror' },
	{ text: 'Science Fiction - Monsters and Mutants', code: 'av_subgenre_science_fiction_monsters_and_mutants' },
	{ text: 'Science Fiction - Psychological', code: 'av_subgenre_science_fiction_psychological' },
	{ text: 'Science Fiction - Robots and Cyborgs', code: 'av_subgenre_science_fiction_robots_and_cyborgs' },
	{ text: 'Science Fiction - Romance', code: 'av_subgenre_science_fiction_romance' },
	{ text: 'Science Fiction - Suspense', code: 'av_subgenre_science_fiction_suspense' },
	{ text: 'Science Fiction - Time Travel and Alternate History', code: 'av_subgenre_science_fiction_time_travel_and_alternate_history' },
	{ text: 'Special Interest', code: 'av_genre_special_interest' },
	{ text: 'Special Interest - Ambiance, Meditation and Screensavers', code: 'av_subgenre_special_interest_ambiance_meditation_and_screensavers' },
	{ text: 'Special Interest - Art', code: 'av_subgenre_special_interest_art' },
	{ text: 'Special Interest - Beauty and Fashion', code: 'av_subgenre_special_interest_beauty_fashion' },
	{ text: 'Special Interest - Business and Finance', code: 'av_subgenre_special_interest_business_finance' },
	{ text: 'Special Interest - Clip', code: 'av_subgenre_special_interest_clip' },
	{ text: 'Special Interest - Crafts and Hobbies', code: 'av_subgenre_special_interest_crafts_hobbies' },
	{ text: 'Special Interest - Educational and Instructional', code: 'av_subgenre_special_interest_educational_and_instructional' },
	{ text: 'Special Interest - Food, Drinks, and Cooking', code: 'av_subgenre_special_interest_food_drinks_and_cooking' },
	{ text: 'Special Interest - Health', code: 'av_subgenre_special_interest_health' },
	{ text: 'Special Interest - Home and Garden', code: 'av_subgenre_special_interest_home_garden' },
	{ text: 'Special Interest - Parenting and Childcare', code: 'av_subgenre_special_interest_parenting_childcare' },
	{ text: 'Special Interest - Politics', code: 'av_subgenre_special_interest_politics' },
	{ text: 'Special Interest - Product Review', code: 'av_subgenre_special_interest_product_review' },
	{ text: 'Special Interest - Sports', code: 'av_subgenre_special_interest_sports' },
	{ text: 'Special Interest - Technology', code: 'av_subgenre_special_interest_technology' },
	{ text: 'Special Interest - Film Trailer', code: 'av_subgenre_special_interest_film_trailer' },
	{ text: 'Special Interest - Travel', code: 'av_subgenre_special_interest_travel' },
	{ text: 'Sports', code: 'av_genre_sports' },
	{ text: 'Sports - American Football', code: 'av_subgenre_sports_american_football' },
	{ text: 'Sports - Aquatic Sports', code: 'av_subgenre_sports_aquatic_sports' },
	{ text: 'Sports - Auto Racing and Formula One', code: 'av_subgenre_sports_auto_racing_and_formula_one' },
	{ text: 'Sports - Badminton', code: 'av_subgenre_sports_badminton' },
	{ text: 'Sports - Baseball', code: 'av_subgenre_sports_baseball' },
	{ text: 'Sports - Basketball', code: 'av_subgenre_sports_basketball' },
	{ text: 'Sports - Billiards and Snooker', code: 'av_subgenre_sports_billiards_snooker' },
	{ text: 'Sports - Combat Sports', code: 'av_subgenre_sports_combat_sports' },
	{ text: 'Sports - Cricket', code: 'av_subgenre_sports_cricket' },
	{ text: 'Sports - Curling', code: 'av_subgenre_sports_curling' },
	{ text: 'Sports - Cycling', code: 'av_subgenre_sports_cycling' },
	{ text: 'Sports - E-Sports', code: 'av_subgenre_sports_esports' },
	{ text: 'Sports - Extreme Sports', code: 'av_subgenre_sports_extreme_sports' },
	{ text: 'Sports - Football (Soccer)', code: 'av_subgenre_sports_football_soccer' },
	{ text: 'Sports - Games', code: 'av_subgenre_sports_games' },
	{ text: 'Sports - Golf', code: 'av_subgenre_sports_golf' },
	{ text: 'Sports - Gymnastics', code: 'av_subgenre_sports_gymnastics' },
	{ text: 'Sports - Handball', code: 'av_subgenre_sports_handball' },
	{ text: 'Sports - Hockey', code: 'av_subgenre_sports_hockey' },
	{ text: 'Sports - Horse', code: 'av_subgenre_sports_horse' },
	{ text: 'Sports - Hunting and Fishing', code: 'av_subgenre_sports_hunting_and_fishing' },
	{ text: 'Sports - Lacrosse', code: 'av_subgenre_sports_lacrosse' },
	{ text: 'Sports - Motorsports', code: 'av_subgenre_sports_motorsports' },
	{ text: 'Sports - Rugby', code: 'av_subgenre_sports_rugby' },
	{ text: 'Sports - Skiing', code: 'av_subgenre_sports_skiing' },
	{ text: 'Sports - Swimming', code: 'av_subgenre_sports_swimming' },
	{ text: 'Sports - Table Tennis', code: 'av_subgenre_sports_table_tennis' },
	{ text: 'Sports - Tennis', code: 'av_subgenre_sports_tennis' },
	{ text: 'Sports - Volleyball', code: 'av_subgenre_sports_volleyball' },
	{ text: 'Sports - Winter Sports', code: 'av_subgenre_sports_winter_sports' },
	{ text: 'Thriller', code: 'av_genre_suspense' },
	{ text: 'Thriller - Action', code: 'av_subgenre_suspense_action' },
	{ text: 'Thriller - Comedy', code: 'av_subgenre_suspense_comedy' },
	{ text: 'Thriller - Crime', code: 'av_subgenre_suspense_crime' },
	{ text: 'Thriller - Drama', code: 'av_subgenre_suspense_drama' },
	{ text: 'Thriller - Espionage', code: 'av_subgenre_suspense_espionage' },
	{ text: 'Thriller - Giallo', code: 'av_subgenre_suspense_giallo' },
	{ text: 'Thriller - Horror', code: 'av_subgenre_suspense_horror' },
	{ text: 'Thriller - Legal', code: 'av_subgenre_suspense_legal' },
	{ text: 'Thriller - Medical', code: 'av_subgenre_suspense_medical' },
	{ text: 'Thriller - Mystery', code: 'av_subgenre_suspense_mystery' },
	{ text: 'Thriller - Political', code: 'av_subgenre_suspense_political' },
	{ text: 'Thriller - Psychological', code: 'av_subgenre_suspense_psychological' },
	{ text: 'Thriller - Romance', code: 'av_subgenre_suspense_romance' },
	{ text: 'Thriller - Science Fiction', code: 'av_subgenre_suspense_science_fiction' },
	{ text: 'Talk Show and Variety', code: 'av_genre_talk_show_and_variety' },
	{ text: 'Talk Show and Variety - Comedy', code: 'av_subgenre_talk_show_variety_comedy' },
	{ text: 'Talk Show and Variety - Daytime Talk Show', code: 'av_subgenre_talk_show_variety_daytime_talk_show' },
	{ text: 'Talk Show and Variety - Entertainment/Celebrity', code: 'av_subgenre_talk_show_variety_entertainment_and_celebrity' },
	{ text: 'Talk Show and Variety - Morning Talk Show', code: 'av_subgenre_talk_show_variety_morning_talk_show' },
	{ text: 'Talk Show and Variety - News', code: 'av_subgenre_talk_show_variety_news' },
	{ text: 'Talk Show and Variety - Political Talk Show', code: 'av_subgenre_talk_show_variety_political_talk_show' },
	{ text: 'Talk Show and Variety - Primetime/Late Night Talk Show', code: 'av_subgenre_talk_show_variety_primetime_and_late_night_talk_show' },
	{ text: 'Talk Show and Variety - Travel Variety', code: 'av_subgenre_talk_show_variety_travel_variety' },
	{ text: 'Talk Show and Variety - Variety', code: 'av_subgenre_talk_show_variety_variety' },
	{ text: 'Talk Show and Variety - Self Help and Lifestyle', code: 'av_subgenre_talk_show_variety_self_help_lifestyle' },
	{ text: 'Unscripted', code: 'av_genre_unscripted' },
	{ text: 'Unscripted - Competition', code: 'av_subgenre_unscripted_competition' },
	{ text: 'Unscripted - Crime', code: 'av_subgenre_unscripted_crime' },
	{ text: 'Unscripted - Dating and Romance', code: 'av_subgenre_unscripted_dating_romance' },
	{ text: 'Unscripted - Docusoap', code: 'av_subgenre_unscripted_docusoap' },
	{ text: 'Unscripted - Hidden Camera', code: 'av_subgenre_unscripted_hidden_camera' },
	{ text: 'Unscripted - Makeover', code: 'av_subgenre_unscripted_makeover' },
	{ text: 'Unscripted - Music and Performance', code: 'av_subgenre_unscripted_music_performance' },
	{ text: 'Unscripted - Sport', code: 'av_subgenre_unscripted_sport' },
	{ text: 'Unscripted - Supernatural', code: 'av_subgenre_unscripted_supernatural' },
	{ text: 'Unscripted - Travel', code: 'av_subgenre_unscripted_travel' },
	{ text: 'Unscripted - Business/Occupation', code: 'av_subgenre_unscripted_business_and_occupation' },
	{ text: 'Western', code: 'av_genre_western' },
	{ text: 'Western - Action', code: 'av_subgenre_western_action' },
	{ text: 'Western - Adventure', code: 'av_subgenre_western_adventure' },
	{ text: 'Western - Comedy', code: 'av_subgenre_western_comedy' },
	{ text: 'Western - Crime', code: 'av_subgenre_western_crime' },
	{ text: 'Western - Drama', code: 'av_subgenre_western_drama' },
	{ text: 'Western - Horror', code: 'av_subgenre_western_horror' },
	{ text: 'Western - Military and War', code: 'av_subgenre_western_military_and_war' },
	{ text: 'Western - Modern', code: 'av_subgenre_western_modern' },
	{ text: 'Western - Romance', code: 'av_subgenre_western_romance' },
	{ text: 'Western - Science Fiction', code: 'av_subgenre_western_science_fiction' },
	{ text: 'Young Adult Audience', code: 'av_genre_young_adult_audience' },
	{ text: 'Young Adult - Action', code: 'av_subgenre_young_adult_action' },
	{ text: 'Young Adult - Adventure', code: 'av_subgenre_young_adult_adventure' },
	{ text: 'Young Adult - Comedy', code: 'av_subgenre_young_adult_comedy' },
	{ text: 'Young Adult - Drama', code: 'av_subgenre_young_adult_drama' },
	{ text: 'Young Adult - Fantasy', code: 'av_subgenre_young_adult_fantasy' },
	{ text: 'Young Adult - Horror', code: 'av_subgenre_young_adult_horror' },
	{ text: 'Young Adult - LGBTQ', code: 'av_subgenre_young_adult_lgbtq' },
	{ text: 'Young Adult - Romance', code: 'av_subgenre_young_adult_romance' },
	{ text: 'Young Adult - Science Fiction', code: 'av_subgenre_young_adult_science_fiction' }
]

const languages = [
	{ code: 'af-ZA', text: 'Afrikaans (South Africa), Afrikaans (Suid-Afrika)' },
	{ code: 'am-ET', text: 'Amharic (Ethiopia)' },
	{ code: 'ar-DZ', text: 'Arabic (Algeria)' },
	{ code: 'ar-BH', text: 'Arabic (Bahrain)' },
	{ code: 'ar-EG', text: 'Arabic (Egypt)' },
	{ code: 'ar-IQ', text: 'Arabic (Iraq)' },
	{ code: 'ar-JO', text: 'Arabic (Jordan)' },
	{ code: 'ar-KW', text: 'Arabic (Kuwait)' },
	{ code: 'ar-LB', text: 'Arabic (Lebanon)' },
	{ code: 'ar-LY', text: 'Arabic (Libya)' },
	{ code: 'ar-MA', text: 'Arabic (Morocco)' },
	{ code: 'ar-OM', text: 'Arabic (Oman)' },
	{ code: 'ar-QA', text: 'Arabic (Qatar)' },
	{ code: 'ar-SA', text: 'Arabic (Saudi Arabia)' },
	{ code: 'ar-SY', text: 'Arabic (Syria)' },
	{ code: 'ar-TN', text: 'Arabic (Tunisia)' },
	{ code: 'ar-AE', text: 'Arabic (United Arab Emirates)' },
	{ code: 'ar-YE', text: 'Arabic (Yemen)' },
	{ code: 'az-AZ', text: 'Azerbaijani (Azerbaijan)' },
	{ code: 'be-BY', text: 'Belarusian (Belarus)' },
	{ code: 'bg-BG', text: 'Bulgarian (Bulgaria)' },
	{ code: 'bh-IN', text: 'Bihari (India)' },
	{ code: 'bi-VU', text: 'Bislama (Vanuatu)' },
	{ code: 'bn-BD', text: 'Bengali (Bangladesh)' },
	{ code: 'bn-IN', text: 'Bengali (India)' },
	{ code: 'ca-ES', text: 'Catalan (Spain)' },
	{ code: 'hr-HR', text: 'Croatian (Croatia), Hrvatski (Hrvatska)' },
	{ code: 'hy-AM', text: 'Armenian (Armenia)' },
	{ code: 'cs-CZ', text: 'Czech (Czech Republic)' },
	{ code: 'da-DK', text: 'Danish (Denmark), Dansk (Danmark)' },
	{ code: 'de-AT', text: 'German (Austria), Deutsch' },
	{ code: 'de-DE', text: 'German (Germany), Deutsch (Deutschland)' },
	{ code: 'de-LI', text: 'German (Liechtenstein), Deutsch (Liechtenstein)' },
	{ code: 'de-LU', text: 'German (Luxembourg), Deutsch (Luxemburg)' },
	{ code: 'de-CH', text: 'German (Switzerland), Deutsch (Schweiz)' },
	{ code: 'dv-MV', text: 'Divehi (Maldives)' },
	{ code: 'el-GR', text: 'Greek (Greece)' },
	{ code: 'en-AU', text: 'English (Australia)' },
	{ code: 'en-BZ', text: 'English (Belize)' },
	{ code: 'en-CA', text: 'English (Canada)' },
	{ code: 'en-IE', text: 'English (Ireland)' },
	{ code: 'en-IN', text: 'English (India)' },
	{ code: 'en-JM', text: 'English (Jamaica)' },
	{ code: 'en-NZ', text: 'English (New Zealand)' },
	{ code: 'en-PH', text: 'English (Philippines)' },
	{ code: 'en-ZA', text: 'English (South Africa)' },
	{ code: 'en-TT', text: 'English (Trinidad & Tobago)' },
	{ code: 'en-GB', text: 'English (UK)' },
	{ code: 'en-US', text: 'English (US)' },
	{ code: 'en-ZW', text: 'English (Zimbabwe)' },
	{ code: 'es-AR', text: 'Spanish (Argentina)' },
	{ code: 'es-BO', text: 'Spanish (Bolivia)' },
	{ code: 'es-CL', text: 'Spanish (Chile)' },
	{ code: 'es-CO', text: 'Spanish (Colombia)' },
	{ code: 'es-CR', text: 'Spanish (Costa Rica)' },
	{ code: 'es-DO', text: 'Spanish (Dominican Republic)' },
	{ code: 'es-EC', text: 'Spanish (Ecuador)' },
	{ code: 'es-ES', text: 'Spanish (Spain)' },
	{ code: 'es-GT', text: 'Spanish (Guatemala)' },
	{ code: 'es-HN', text: 'Spanish (Honduras)' },
	{ code: 'es-MX', text: 'Spanish (Mexico)' },
	{ code: 'es-NI', text: 'Spanish (Nicaragua)' },
	{ code: 'es-PA', text: 'Spanish (Panama)' },
	{ code: 'es-PE', text: 'Spanish (Peru)' },
	{ code: 'es-PR', text: 'Spanish (Puerto Rico)' },
	{ code: 'es-PY', text: 'Spanish (Paraguay)' },
	{ code: 'es-SV', text: 'Spanish (El Salvador)' },
	{ code: 'es-UY', text: 'Spanish (Uruguay)' },
	{ code: 'es-VE', text: 'Spanish (Venezuela)' },
	{ code: 'et-EE', text: 'Estonian (Estonia)' },
	{ code: 'eu-ES', text: 'Basque (Spain), Euskara (Espainia)' },
	{ code: 'fa-IR', text: 'Persian (Iran)' },
	{ code: 'fi-FI', text: 'Finnish (Finland), Suomi (Suomi)' },
	{ code: 'fo-FO', text: 'Faroese (Faroe Islands)' },
	{ code: 'fr-BE', text: 'French (Belgium)' },
	{ code: 'fr-CA', text: 'French (Canada)' },
	{ code: 'fr-CH', text: 'French (Switzerland)' },
	{ code: 'fr-FR', text: 'French (France)' },
	{ code: 'fr-LU', text: 'French (Luxembourg)' },
	{ code: 'fr-MC', text: 'French (Monaco)' },
	{ code: 'ga-IE', text: 'Irish (Ireland)' },
	{ code: 'gl-ES', text: 'Galician (Spain)' },
	{ code: 'gu-IN', text: 'Gujarati (India)' },
	{ code: 'he-IL', text: 'Hebrew (Israel)' },
	{ code: 'hi-JP', text: 'Hindi (Japan)' },
	{ code: 'hi-IN', text: 'Hindi (India)' },
	{ code: 'hu-HU', text: 'Hungarian (Hungary)' },
	{ code: 'id-ID', text: 'Indonesian (Indonesia)' },
	{ code: 'is-IS', text: 'Icelandic (Iceland)' },
	{ code: 'it-IT', text: 'Italian (Italy), Italiano (Italia)' },
	{ code: 'it-CH', text: 'Italian (Switzerland), Italiano (Svizzera)' },
	{ code: 'ja-JP', text: 'Japanese (Japan)' },
	{ code: 'ka-GE', text: 'Georgian (Georgia)' },
	{ code: 'kk-KZ', text: 'Kazakh (Kazakhstan)' },
	{ code: 'kn-IN', text: 'Kannada (India)' },
	{ code: 'km-KH', text: 'Khmer (Cambodia)' },
	{ code: 'ko-KR', text: 'Korean (South Korea)' },
	{ code: 'ky-KZ', text: 'Kyrgyz (Kazakhstan)' },
	{ code: 'lo-LA', text: 'Lao (Lao People\'s Democratic Republic)' },
	{ code: 'lb-LU', text: 'Luxembourgish (Luxembourg)' },
	{ code: 'lt-LT', text: 'Lithuanian (Lithuania)' },
	{ code: 'lv-LV', text: 'Latvian (Latvia)' },
	{ code: 'mh-MH', text: 'Marshallese (Marshall Islands)' },
	{ code: 'mk-MK', text: 'Macedonian (Macedonia)' },
	{ code: 'ml-IN', text: 'Malayalam (India)' },
	{ code: 'mn-MN', text: 'Mongolian (Mongolia)' },
	{ code: 'mr-IN', text: 'Marathi (India)' },
	{ code: 'ms-BN', text: 'Malay (Brunei), Bahasa Melayu (Brunei)' },
	{ code: 'ms-MY', text: 'Malay (Malaysia), Bahasa Melayu (Malaysia)' },
	{ code: 'mt-MT', text: 'Maltese (Malta), Malti (Malta)' },
	{ code: 'my-MM', text: 'Burmese (Myanmar)' },
	{ code: 'na-NR', text: 'Nauruan (Nauru), dorerin Naoero (Naoero)' },
	{ code: 'nb-NO', text: 'Norwegian Bokm (Norway), Norsk Bokm (Norge)' },
	{ code: 'ne-NP', text: 'Nepali (Nepal)' },
	{ code: 'nl-BE', text: 'Dutch (Belgium)' },
	{ code: 'nl-NL', text: 'Dutch (Netherlands), Nederlands (Nederland)' },
	{ code: 'nn-NO', text: 'Norwegian Nynorsk (Norway), Nynorsk (Noreg)' },
	{ code: 'or-IN', text: 'Oriya (India)' },
	{ code: 'pa-IN', text: 'Punjabi (India)' },
	{ code: 'pa-PK', text: 'Punjabi (Pakistan)' },
	{ code: 'pl-PL', text: 'Polish (Poland), Polski (Polska)' },
	{ code: 'pt-BR', text: 'Portuguese (Brazil)' },
	{ code: 'pt-PT', text: 'Portuguese (Portugal)' },
	{ code: 'ro-RO', text: 'Romanian (Romania)' },
	{ code: 'rw-RW', text: 'Kinyarwanda (Rwanda), Kinyarwanda (U Rwanda)' },
	{ code: 'ru-RU', text: 'Russian (Russia)' },
	{ code: 'sa-IN', text: 'Sanskrit (India)' },
	{ code: 'si-LK', text: 'Sinhala (Sri Lanka)' },
	{ code: 'sk-SK', text: 'Slovak (Slovakia), Sloven (Slovensko)' },
	{ code: 'sl-SI', text: 'Slovenian (Slovenia), Sloven (Slovenija)' },
	{ code: 'sm-WS', text: 'Samoan (Samoa), Samoa (Samoa)' },
	{ code: 'sn-ZW', text: 'Shona (Zimbabwe)' },
	{ code: 'so-SO', text: 'Somali (Somalia), Somali (Soomaaliya)' },
	{ code: 'sq-AL', text: 'Albanian (Albania)' },
	{ code: 'sr-RS', text: 'Serbian (Serbia)' },
	{ code: 'sw-KE', text: 'Swahili (Kenya), Kiswahili (Kenya)' },
	{ code: 'sv-FI', text: 'Swedish (Finland), Svenska (Finland)' },
	{ code: 'sv-SE', text: 'Swedish (Sweden), Svenska (Sverige)' },
	{ code: 'syr-SY', text: 'Syriac (Syria)' },
	{ code: 'ta-IN', text: 'Tamil (India)' },
	{ code: 'te-IN', text: 'Telugu (India)' },
	{ code: 'ti-ER', text: 'Tigrinya (Eritrea)' },
	{ code: 'tg-TJ', text: 'Tajik (Tajikistan)' },
	{ code: 'th-TH', text: 'Thai (Thailand)' },
	{ code: 'tk-TM', text: 'Turkmen (Turkmenistan)' },
	{ code: 'tr-TR', text: 'Turkish (Turkey)' },
	{ code: 'tt-RU', text: 'Tatar (Russia)' },
	{ code: 'uk-UA', text: 'Ukrainian (Ukraine)' },
	{ code: 'ur-PK', text: 'Urdu (Pakistan)' },
	{ code: 'uz-UZ', text: 'Uzbek (Uzbekistan)' },
	{ code: 'vi-VN', text: 'Vietnamese (Vietnam)' },
	{ code: 'fil-PH', text: 'Filipino (Philippines), Filipino (Pilipinas)' },
	{ code: 'kok-in', text: 'Konkani (India)' },
	{ code: 'mni-in', text: 'Manipuri (India)' },
	{ code: 'sdp-IN', text: 'Sherdukpen (India), Mey nyuk (India)' },
	{ code: 'es-419', text: 'Spanish (Latin America)' },
	{ code: 'zh-Hans', text: 'Chinese (Simplified) -- timed text only' },
	{ code: 'zh-Hant', text: 'Chinese (Traditional) -- timed text only' },
	{ code: 'zh-CN', text: 'Chinese (Simplified) -- metadata only' },
	{ code: 'zh-TW', text: 'Chinese (Traditional) -- metadata only' },
	{ code: 'cmn-CN', text: 'Mandarin (Mainland China accent) -- video/audio only' },
	{ code: 'cmn-TW', text: 'Mandarin (Taiwanese accent) -- video/audio only' },
	{ code: 'yue', text: 'Cantonese -- video/audio only' }
]

const globalRating = {
	AMAZON_MATURITY_RATING: {
		type: [
			'Film',
			'Trailer',
			'TV'
		],
		ratings: [
			'ALL',
			'7+',
			'13+',
			'16+',
			'18+'
		],
		reasons: [
			{
				text: 'violence',
				value: 'violence'
			},
			{
				text: 'nudity',
				value: 'nudity'
			},
			{
				text: 'sexual content',
				value: 'sexuality'
			},
			{
				text: 'foul_language',
				value: 'foul_language'
			},
			{
				text: 'substance_use',
				value: 'substance_use'
			},
			{
				text: 'alcohol use',
				value: 'alcohol'
			},
			{
				text: 'smoking',
				value: 'smoking'
			},
			{
				text: 'frightening_scenes',
				value: 'frightening_scenes'
			},
			{
				text: 'blackface',
				value: 'blackface'
			},
			{
				text: 'brownface',
				value: 'brownface'
			},
			{
				text: 'redface',
				value: 'redface'
			},
			{
				text: 'yellowface',
				value: 'yellowface'
			},
			{
				text: 'flashing_lights',
				value: 'flashing_lights'
			},
			{
				text: 'this program contains product placement',
				value: 'product_placement'
			}
		]
	}
}
let jsonRatings = require('./amazon_ratings.json')
for (const key in jsonRatings) {
	jsonRatings[key].systems.AMAZON_MATURITY_RATING = globalRating.AMAZON_MATURITY_RATING
	// 	...jsonRatings[key].systems,
	// 	...globalRating
	// }
}
const ratings = jsonRatings

const altIdentifier_namespaces = [
	'EIDR',
	'ISAN',
	'IMDB',
	'ORG'
]

const art_purposes = [
	'boxart',
	'cover',
	'cover_unbranded',
	'hero',
	'poster',
	'title'
]

const asset_types = [
	'Video',
	'Dubcard',
	'Audio',
	'Subtitle'
]

const asset_types_identifiers = {
	Video: 'vidtrackid',
	Dubcard: 'vidtrackid',
	Audio: 'audtrackid',
	Subtitle: 'subtrackid'
}

const asset_roles = [
	'Feature',
	'Trailer'
]

const audio_types = [
	'primary',
	'narration',
	'dialog centric',
	'commentary'
]

const subtitle_types = [
	'Normal',
	'SDH',
	'Forced'
]

const subtitle_framerates = [
	{
		label: '23.98',
		FrameRate: '24',
		Multiplier: '1000/1001'
	},
	{
		label: '24',
		FrameRate: '24',
		Multiplier: false
	},
	{
		label: '25',
		FrameRate: '25',
		Multiplier: false
	},
	{
		label: '29.97',
		FrameRate: '30',
		Multiplier: '1000/1001'
	},
	{
		label: '30',
		FrameRate: '30',
		Multiplier: false
	}
]

const subtitle_timecodes = {
	true: 'Drop',
	false: 'NonDrop'
}

const scan_order = [
	'TFF',
	'BFF'
]

const partner_aliases = [
	'tf1distribution',
	'metropolitan',
	'umwi',
	'originalsfactory',
	'aboutpremiumcontent',
	'newen',
	'federation_ent',
	'bureaufilms',
	'groupeab',
	'pathe',
	'orange',
	'le_pacte',
	'mk2_films',
	'wildside',
	'europacorp',
	'fr_television',
	'kew',
	'memento',
	'societe_nouvelle',
	'ugc',
	'paris_sg',
	'NBCUniversal'
]

const job_functions = [
	'Actor',
	'Creator',
	'Director',
	'GuestActor',
	'Producer',
	'Writer'
]

const isValidLanguage = (languageCode) => {
	let languageItem = languages.find(item => item.code === languageCode)
	if (languageItem) return true
	return false
}

const getLanguageLabel = (languageCode) => {
	let languageItem = languages.find(item => item.code === languageCode)
	if (languageItem) return languageItem.text
	return ''
}

module.exports = {
	ReleaseType,
	package_types,
	WorkType,
	// WorkTypeLabels,
	relationshipType,
	countries,
	genres,
	languages,
	ratings,
	altIdentifier_namespaces,
	art_purposes,
	asset_types,
	asset_types_identifiers,
	audio_types,
	subtitle_types,
	subtitle_framerates,
	subtitle_timecodes,
	scan_order,
	asset_roles,
	partner_aliases,
	job_functions,
	isValidLanguage,
	getLanguageLabel
}



// WEBPACK FOOTER //
// ./src/pages/packages/amazon_package_global/amazon_enums.js